import type { JwtPayload } from '../types/api';

export function decodeJwtPayload(token: string): JwtPayload | null {
    try {
        const part = token.split('.')[1];
        if (!part) {
            return null;
        }
        const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(json) as JwtPayload;
    } catch {
        return null;
    }
}

/** Platform-scoped role names from the access token. */
export function getPlatformRoles(payload: JwtPayload | null): string[] {
    return payload?.platformRoles ?? [];
}

/** Organization memberships from the access token. */
export function getOrganizationClaims(payload: JwtPayload | null) {
    return payload?.organizations ?? [];
}

/** Whether the token grants access to the platform admin UI. */
export function isAdminPayload(payload: JwtPayload | null): boolean {
    if (!payload) {
        return false;
    }
    if (payload.isPlatformAdmin) {
        return true;
    }
    return getPlatformRoles(payload).includes('admin');
}
